export type SafeStorage = {
    getItem: (key: string) => string | null
    setItem: (key: string, value: string) => void
    removeItem: (key: string) => void
}

export const getLocalStorageAdapter = (): SafeStorage => getStorageAdapter('localStorage')

const getStorageAdapter = (type: 'localStorage' | 'sessionStorage'): SafeStorage => {
    if (typeof globalThis === 'undefined') {
        return NOOP_STORAGE
    }

    const runtimeStorage = (globalThis as { localStorage?: Partial<Storage>; sessionStorage?: Partial<Storage> })[type]
    if (!runtimeStorage) {
        return NOOP_STORAGE
    }

    if (
        typeof runtimeStorage.getItem !== 'function' ||
        typeof runtimeStorage.setItem !== 'function' ||
        typeof runtimeStorage.removeItem !== 'function'
    ) {
        return NOOP_STORAGE
    }

    return {
        getItem: runtimeStorage.getItem.bind(runtimeStorage),
        setItem: runtimeStorage.setItem.bind(runtimeStorage),
        removeItem: runtimeStorage.removeItem.bind(runtimeStorage),
    }
}

const NOOP_STORAGE: SafeStorage = {
    getItem: () => null,
    setItem: () => undefined,
    removeItem: () => undefined,
}
